export const FETCH_CHEMISTORDERDETAILS_INIT_ACTION =
  "FETCH_CHEMISTORDERDETAILS_INIT_ACTION";
export const FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION =
  FETCH_CHEMISTORDERDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTORDERDETAILS_FAIL_ACTION =
  FETCH_CHEMISTORDERDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_CHEMISTORDERVIEW_INIT_ACTION =
  "FETCH_CHEMISTORDERVIEW_INIT_ACTION";
export const FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION =
  FETCH_CHEMISTORDERVIEW_INIT_ACTION + "_SUCCESS";
export const FETCH_CHEMISTORDERVIEW_FAIL_ACTION =
  FETCH_CHEMISTORDERVIEW_INIT_ACTION + "_ERROR";

export function fetchChemistOrders(value) {
  return {
    type: FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
    value: value
  };
}

export function pageSelected(value) {
  return {
    type: FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
    value: value
  };
}
export function ChemistOrdersview(value) {
  return {
    type: FETCH_CHEMISTORDERVIEW_INIT_ACTION,
    value: value
  };
}

export function itempageSelected(value) {
  return {
    type : FETCH_CHEMISTORDERVIEW_INIT_ACTION,
    value:value,
  }
}
